module.exports = __webpack_public_path__ + "static/media/androidplay.d9d749c1.svg";